module.exports = __webpack_public_path__ + "media/images/covers/foundation/Queen-Mary-University-of-London-logo-5ba188d05b464a3793d667b7b930b4c4.svg";